import BaseElement from './BaseElement';
import Accordion from '../Components/Mediathek/Accordion';
class AccordionElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = Accordion;
    }
}
export default AccordionElement;
